import API, { handleRequest } from "@/api/lib/api";

export const getOrderHistory = (params) =>
  handleRequest(() =>
    API.get(`restaurant/${params.restaurant_id}/order-history`, { params }),
  );

export const voidOrder = (order_id, data) =>
  handleRequest(() =>
    API.put(`restaurant/order-history/${order_id}/void`, data),
  );

export const fullReplacedOrder = (order_id) =>
  handleRequest(() =>
    API.put(`restaurant/order-history/${order_id}/mark-fully-replaced`),
  );

export const banCustomer = (customer_id) =>
  handleRequest(() => API.put(`restaurant/order-history/customer/${customer_id}/ban`));

export const compensationOrder = (order_id, data) =>
  handleRequest(() =>
    API.post(`restaurant/order-history/${order_id}/order-compensation`, data),
  );

export const sendCompensationNotification = (order_id, data) =>
  handleRequest(() =>
    API.post(`restaurant/order-history/${order_id}/order-compensation/send`, data),
  );

export const sendOrderEmail = (order_id, data) =>
  handleRequest(() =>
    API.post(`restaurant/order-history/${order_id}/email`, data),
  );

export const printConcessionSlip = (id) =>
  handleRequest(() =>
    API.get(`restaurant/order-history/${id}/concession_print`),
  );

export const createRestaurantOtp = (data) =>
  handleRequest(() =>
    API.post(`restaurant/otp/create`, data),
  );

export const deleteOrderHistory = (data) =>
  handleRequest(() =>
    API.delete(`restaurant/order-history`, { data }),
  );

export const deleteSingleOrder = (order_id) =>
  handleRequest(() =>
    API.delete(`restaurant/order-history/${order_id}`),
  );

